import { Checkbox, Input } from '@/components';
import type { RoleListItem } from '@uchat-team-management/shared';
import { For, Show, createMemo, createSignal } from 'solid-js';

export const RoleMultiSelect = (props: {
  roles: readonly RoleListItem[];
  selected: Set<string>;
  onToggle: (roleId: string) => void;
}) => {
  const [filter, setFilter] = createSignal('');
  // Selection lives in the caller's Set, so filtered-out picks stay selected.
  const visible = createMemo(() => {
    const q = filter().trim().toLowerCase();
    if (!q) return props.roles;
    return props.roles.filter((role) => role.name.toLowerCase().includes(q));
  });

  return (
    <div class="flex flex-col gap-2 text-sm">
      <span class="font-medium">Roles</span>
      <Input
        aria-label="Search roles"
        placeholder="Search roles"
        value={filter()}
        onInput={(e) => setFilter(e.currentTarget.value)}
        class="max-w-xs"
      />
      <div class="flex flex-wrap gap-2">
        <For each={visible()}>
          {(role) => (
            <Checkbox
              class="rounded-lg border border-neutral-300 px-2 py-1 text-xs dark:border-neutral-700"
              checked={props.selected.has(role.id)}
              onChange={() => props.onToggle(role.id)}
              label={role.name}
            />
          )}
        </For>
        <Show when={visible().length === 0}>
          <span class="text-xs text-neutral-500">No roles match "{filter().trim()}"</span>
        </Show>
      </div>
    </div>
  );
};
